import persistReducer from 'redux-persist/es/persistReducer';
import storage from 'redux-persist/lib/storage';
import { studentAdmissionReducer } from '../Slices/studentAdmission.slice';

const admissionStudentPersistConfig = {
  key: 'admission-student',
  version: 2,
  storage,
};

export const persistStudentAdmission = persistReducer(
  admissionStudentPersistConfig,
  studentAdmissionReducer
);
